import { z } from "zod";

export const getUserSignupSchema = (useFirebase = true) => {
	return z.object({
		email: useFirebase
			? z.string().refine((email) => z.string().email().safeParse(email).success, {
					message: "Please enter a valid email.",
				})
			: z.string().min(1, { message: "Please enter an email or username." }),
		password: z
			.string()
			.min(6, { message: "Please enter a password at least 6 characters long." }),
		termsAccepted: z.boolean().refine((val) => val === true, {
			message: "You must accept the terms and conditions.",
		}),
		fname: useFirebase
			? z.string().min(1, { message: "Please enter a valid first name." })
			: z.string().optional(),
		lname: useFirebase
			? z.string().min(1, { message: "Please enter a valid last name." })
			: z.string().optional(),
	});
};

export type UserSignupSchema = z.infer<ReturnType<typeof getUserSignupSchema>>;
